import React from 'react';
import { Route } from 'react-router-dom'
import { Layout, Row, Col } from 'antd';
import Copyright from '../components/footer/Copyright';
import { Suspense } from 'react';

const { Content } = Layout;

/* Login Layout */
const LoginLayout = ({ children, ...rest }) => {
  return (
    <div className="account_layout">
      <Row gutte={5} className="header">
        <Col span={20}>
          {/* <Link to="/" className="logo" /> */}
        </Col>
        <Col span={4}>
          <div className="float-right">
            {/* <Languages></Languages> */}
          </div>
        </Col>
      </Row>
      <Content >
        <div className='tb--modal-lvl1'>
          <div className='tb--modal-lvl2'>
            <div className='tb--modal-lvl3'>
              <div className="form-container" >
                <div className="logo">
                </div>
                <div className="form-group">
                  <div className="main">{children}</div>
                </div>
                <Copyright />
              </div>
            </div>
          </div>
        </div>

      </Content>
    </div>
  )
}

/*
  Route wrapper for React Router v6
 */
export const LoginLayoutRoute = ({ component: Component, ...rest }) => {
  return (
    <LoginLayout>
      <Suspense fallback={<></>}>
        <Component {...rest} />
      </Suspense>
    </LoginLayout>
  );
};